export class PageSchemaMetadata {
    callback?: Function;
    name: string;
}
